<template>
  <form id="destination_instagramRtmp_form">
    <b-tabs card>
      <b-tab no-body title="افزودن مقصد" active class="mt-2">
        <div class="card card-custom gutter-b">
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">
                افزودن مقصد
                {{ destinationNames.instagramRtmp }}
              </h3>
            </div>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label>نام</label>
              <input type="text" name="name" v-model="form.name" class="form-control" />
            </div>
            <div class="form-group">
              <label>آدرس استریم‌</label>
              <input type="text" name="stream_url" dir="ltr" placeholder="Stream Url" v-model="form.details.stream_url"
                class="form-control" />
            </div>
            <div class="form-group">
              <label>کلید استریم‌</label>
              <input type="text" name="stream_key" dir="ltr" placeholder="Stream Key" v-model="form.details.stream_key"
                class="form-control" />
            </div>
            <div class="form-group">
              <label class="checkbox mb-0">
                <input type="checkbox" name="rotation" true-value="90" false-value="0" v-model="form.rotation" />
                <span class="mr-2"></span>
                چرخش ۹۰ درجه
              </label>
            </div>
            <div class="form-group">
              <label class="checkbox mb-0">
                <input type="checkbox" name="proxy_status" true-value="1" false-value="2" v-model="form.proxy_status" />
                <span class="mr-2"></span>
                استفاده از پروکسی
              </label>
            </div>


          </div>
        </div>
      </b-tab>
      <b-tab no-body class="mt-2">
        <template v-slot:title>
          <div class="d-flex align-items-center">
            <i class="flaticon2-play text-primary mr-3" style="font-size: 1.3rem;"></i>
            <span class="font-weight-bolder">آموزش</span>
          </div>
        </template>

        <div class="card card-custom gutter-b shadow-sm border-0">
          <div class="card-body p-8">
            <div class="d-flex align-items-center mb-6">
              <div class="symbol symbol-60 symbol-light-primary flex-shrink-0 mr-6">
                <span class="symbol-label text-center">
                  <i class=" flaticon-presentation-1 icon-2x text-primary font-size-sx text-bold"></i>
                </span>
              </div>
              <div class="d-flex flex-column">
                <h4 class="text-dark-75 font-weight-bolder mb-2">
                  آموزش تصویری و گام‌به‌گام استریم زنده در اینستاگرام با RTMP
                </h4>
                <p class="text-muted font-size-sm">
                  چطور با لینک RTMP و کلید استریم، لایو اینستاگرام رو با OBS یا نرم‌افزارهای حرفه‌ای اجرا کنیم؟
                </p>
              </div>
            </div>

            <a href="https://blog.mirol.ir/9/post" target="_blank"
              class="btn btn-primary font-weight-bolder px-8 py-4 rounded-lg education-btn">
              <i class="flaticon2-play mr-3"></i>
              مشاهده آموزش کامل
              <i class="flaticon2-next ml-3"></i>
            </a>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </form>
</template>
<style scoped>
.education-btn {
  background: linear-gradient(135deg, #4F46E5 0%, #6366f1 100%) !important;
  border: none !important;
  box-shadow: 0 4px 15px rgba(79, 70, 229, 0.2);
  transition: all 0.3s ease !important;
}

.education-btn:hover {
  box-shadow: 0 10px 25px rgba(79, 70, 229, 0.4) !important;
  transform: translateY(-2px);
}
</style>
<script>
import { mapGetters } from "vuex";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";

export default {
  name: "CrInstagramRtmpDestination",
  props: {
    isCompany: Boolean,
    isAdmin: Boolean
  },
  data() {
    return {
      form: {
        name: "",
        details: {
          stream_url: "",
          stream_key: ""
        },
        rotation: "90",
        proxy_status: "1",
        auto_connect: "0",
        editable: "1"
      },
      showPassword: false
    };
  },
  mounted() {
    this.fv = formValidation(
      document.getElementById("destination_instagramRtmp_form"),
      {
        fields: {
          name: {
            validators: {
              notEmpty: {
                message: "نام الزامی است"
              }
            }
          }
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap()
        }
      }
    );
  },
  computed: {
    ...mapGetters(["destinationNames"])
  }
};
</script>
